import { render, staticRenderFns } from "./PixelDialog.vue?vue&type=template&id=90f277dc"
import script from "./PixelDialog.vue?vue&type=script&lang=js"
export * from "./PixelDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports